module.exports = __webpack_public_path__ + "static/media/nn-Nonord-C-Y-A-kan-du-no-gjenta.a9530da7.mp3";